import React from "react";
import { Link } from "react-router-dom";

function Card({ item }) {
  return (
    <Link to={`/categories/${item?.slug || item?.slugPath}`} className="custom-category-card text-decoration-none">
      {/* IMAGE */}
      <div className="category-image-container">
        <img
          src={item?.image}
          alt={item?.name}
          className="custom-category-image"
        />

        {/* OVERLAY */}
        <div className="custom-category-overlay"></div>

        {/* SPOTLIGHT */}
        <div className="spotlight-layer"></div>
      </div>

      {/* VERTICAL LABEL */}
      <div className="vertical-label">
        {item?.name}
      </div>

      {/* CONTENT */}
      <div className="custom-category-content p-3">
        <span className="custom-category-tag">
          LUXE DIRECTORY
        </span>

        <h3 className="custom-category-title mb-0">
          {item?.name}
        </h3>

        <Link
       to={`/categories/${item?.slug || item?.slugPath}`}
          className="custom-category-btn text-decoration-none"
        >
          Explore &rarr;
        </Link>
      </div>
    </Link>
  );
}

export default Card;